import React from 'react';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { st, classes } from './list-item-container.st.css';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
const ListItemContainer = React.forwardRef(({ id, isMarked, isReply, dataHook, isPending, children, className }, ref) => {
    const { screenshotMode } = useConfiguration();
    const isMobile = useApi(getIsMobile);
    return (React.createElement("div", { ref: ref, tabIndex: -1, id: id, "data-hook": dataHook, className: st(classes.root, { isMobile, isPending, isReply, noTransitions: !!screenshotMode, isMarked: !!isMarked }, className) },
        React.createElement("div", { className: st(classes.highlight, 'wc-comment-highlight') }),
        React.createElement("div", { className: classes.innerContainer }, children)));
});
export default ListItemContainer;
//# sourceMappingURL=list-item-container.js.map